<template>
  <v-form v-model="valid" ref="teamCreateForm">
    <v-card-text>
      <v-text-field
        v-model="name"
        :label="`${$t('team.name')}`"
        :rules="nameRules"
        required
      ></v-text-field>
      <v-checkbox v-model="assignHidden" :label="`${$t('team.create.assign_hidden')}`"></v-checkbox>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-progress-circular
        indeterminate
        color="primary"
        v-if="loading"
        spacing="pr-4"
      ></v-progress-circular>
      <v-btn color="primary" @click="create" :disabled="loading">
        {{ $t('base.create') }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>

export default {
  data() {
    return {
      name: "",
      assignHidden: false,
      loading: false,
      valid: false,
      nameRules: [
        (v) => !!v || this.$t('team.create.error.no-name-msg'),
        (v) => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('team.create.error.first-letter-msg'),
        (v) => v.length > 2 || this.$t('team.create.error.min-length-3'),
        (v) => !this.teams.find(team => team.name === v) || this.$t('team.create.error.name-in-use')
      ]
    }
  },
  computed: {
    teams() {
      return this.$store.state.teams
    },
  },
  methods: {
    create() {
      if(this.$refs.teamCreateForm.validate()) {
        this.loading = true
        this.$store.dispatch("createTeam", {
          "name": this.name,
          "assign_hidden": this.assignHidden ? 1: 0
        }).then(() => {
          this.$store.commit("setSnack", {
            message: this.$t("team.create.success-message", { "team-name": this.name }),
            color: "success"
          })
          this.$refs.teamCreateForm.reset()
          this.$emit("exit")
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}

</script>

<style scoped>
</style>
